export const bwsShowcaseFeatures = [
  {
    id: "public-website",
    title: "Public Business Website",
    image: "/images/products/business-website-suite/public-website.png",
    description:
      "Every tenant gets a polished, mobile-ready site with hero sections, service listings, testimonials, and online booking. Sparkle Auto Wash and other demo sites show how industry templates turn into a professional web presence in minutes — no developer required.",
  },
  {
    id: "online-booking",
    title: "Online Booking",
    image: "/images/products/business-website-suite/book-appointment.png",
    description:
      "Customers book right from the website — they pick a service, choose a date and time, and add any notes. Every appointment flows straight into the owner CRM, so the calendar fills up automatically without a single phone call.",
  },
  {
    id: "instant-quotes",
    title: "Instant Quote Requests",
    image: "/images/products/business-website-suite/get-a-quote.png",
    description:
      "Prospects request a personalized quote in seconds by describing their project and selecting a service. Each request lands in the CRM as a fresh lead — ready for the owner to follow up and win the job. Contact and lead-capture forms feed the same pipeline.",
  },
  {
    id: "owner-dashboard",
    title: "Owner CRM Dashboard",
    image: "/images/products/business-website-suite/owner-crm-dashboard.png",
    description:
      "Business owners log in to a unified dashboard to track leads, manage appointments, review quote requests, and see customer activity at a glance. New bookings and inquiries from the website flow straight in — so nothing falls through the cracks.",
  },
  {
    id: "branding",
    title: "Website & Branding Control",
    image: "/images/products/business-website-suite/branding-customization.png",
    description:
      "Owners customize their logo, hero background, gallery images, and business profile straight from the dashboard — no code required. Every change goes live instantly, with a Preview Site button to review the public page before it ships.",
  },
  {
    id: "industry-templates",
    title: "Industry Templates",
    image: "/images/products/business-website-suite/industry-templates.png",
    description:
      "Pre-built templates for car washes, plumbing, restaurants, HVAC, and more — each with tailored services, copy, and styling. Pick a vertical, enter business details, and launch a complete site plus CRM in days instead of months.",
  },
];
